import React, { useEffect, SetStateAction } from 'react';
import { ApplicationMethod, Fields } from 'src/components/CustomisationPage/feature/customisation.types';
import { Fieldset } from 'src/components/Forms/Fieldset';
import { RadioGroup } from 'src/core/forms';
import { CustomRadioMethod } from 'src/components/CustomisationPage/CustomRadioMethod';
import classes from 'src/components/CustomisationPage/CustomRadioMethod.scss';
import { useFormApi } from 'src/core/forms';
import { useFieldValue } from 'src/core/forms';
import classnames from 'classnames';
import { MethodInfo } from 'src/components/CustomisationPage/steps/MethodInfo';

type MethodFieldsetProps = {
    fieldPrefix?: string;
    applicationMethodFromLocations: ApplicationMethod;
    fieldIndex?: number;
    numberOfArtworks?: number;
    applicationMethodId: string;
    setApplicationMethodId: React.Dispatch<SetStateAction<string>>;
    recommendedApplication?: ApplicationMethod;
    className?: string;
};
export const MethodFieldset: React.FC<MethodFieldsetProps> = ({
    fieldIndex,
    fieldPrefix = '',
    applicationMethodFromLocations,
    numberOfArtworks,
    applicationMethodId,
    setApplicationMethodId,
    recommendedApplication,
    className,
}) => {
    const field = `${fieldPrefix}${Fields.applicationMethod}`;
    const api = useFormApi();
    const artworkOneApplicationMethod = useFieldValue(`${1}.${'bundle-customisation'}.${'applicationMethod'}`);
    const embroidery = [ApplicationMethod.Embroidery, ApplicationMethod.Both].includes(applicationMethodFromLocations);
    const print = [ApplicationMethod.Print, ApplicationMethod.Both].includes(applicationMethodFromLocations);

    const initialValue = () => {
        if (recommendedApplication) return String(recommendedApplication);

        return embroidery ? String(ApplicationMethod.Embroidery) : String(ApplicationMethod.Print);
    };

    useEffect(() => {
        setApplicationMethodId(initialValue());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Keep same method for all artworks
    useEffect(() => {
        if (numberOfArtworks && artworkOneApplicationMethod) {
            [...Array(numberOfArtworks).keys()].map((i) => {
                if (i + 1 === 1) return;
                api.setValues({
                    [`${i + 1}.${'bundle-customisation'}.${'applicationMethod'}`]: String(artworkOneApplicationMethod),
                });
            });
        }
    }, [artworkOneApplicationMethod, numberOfArtworks, api]);

    const computedCustomRadioMethod = (isEmbroidery: boolean, disabled: boolean) => (
        <CustomRadioMethod
            value={isEmbroidery ? String(ApplicationMethod.Embroidery) : String(ApplicationMethod.Print)}
            id={
                fieldIndex
                    ? `${fieldIndex}${isEmbroidery ? 'embroidery' : 'print'}`
                    : isEmbroidery
                      ? 'embroidery'
                      : 'print'
            }
            icon={isEmbroidery ? 'embroidery' : 'print'}
            title={isEmbroidery ? 'Embroidery' : 'Print'}
            description={
                isEmbroidery
                    ? 'Embroidery (or stitching) is detailed and durable which is better suited to uniforms.'
                    : 'The print application method is both vivid and flexible, ideal for general use.'
            }
            disabled={disabled}
            image={require(`../../../../static/img/new${isEmbroidery ? 'Embroidery' : 'Print'}.png`)}
            setApplicationMethodId={setApplicationMethodId}
            applicationMethodId={applicationMethodId}
            isRecommended={
                isEmbroidery
                    ? recommendedApplication === ApplicationMethod.Embroidery
                    : recommendedApplication === ApplicationMethod.Print
            }
            stitching={isEmbroidery}
        />
    );

    return (
        <Fieldset disabled={false}>
            {(!embroidery || !print) && <MethodInfo noEmbroidery={!embroidery} noPrint={!print} />}
            <RadioGroup field={field} initialValue={initialValue()}>
                {fieldIndex === 1 || !fieldIndex ? (
                    <div className={classnames(classes.customMethodsBackground, className)}>
                        <div className={classes.customMethodsWrapper}>
                            <div className={classes.customMethods}>
                                {computedCustomRadioMethod(true, !embroidery)}
                                {computedCustomRadioMethod(false, !print)}
                            </div>
                        </div>
                    </div>
                ) : null}
            </RadioGroup>
        </Fieldset>
    );
};
